import React, { useContext, useEffect, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux';

import NavbarPriceboard from './layout/navbar';

import {
  setCategory,
  saveCategoryRequest,
} from '../../../containers/client/actions';

import {
  snapshotRequest,
  ptListRequest,
  psListRequest,
  cwListRequest,
  bondListRequest,
  list30Request,
  listEtfRequest,
  clearPartRequest,
  clearSnapshotRequest,
  loleSnapshotRequest,
  loleHSXSnapshotRequest,
  getStockByIdRequest,
  psSnapshotRequest,
  snapshotUnderlyingCWRequest,
} from '../../../containers/banggia/actions';

import * as _ from 'lodash';

import { WebSocketContext } from '../../../containers/socket/webSocket';
import { WindowContext } from '../../../containers/windowActive';
import {
  makeGetToken,
  makeGetDefaultAccount,
  makeGetTypeIndex,
  makeGetSnapShot,
  makeGetCategory,
  makeGetCategorySelected,
  makeGetAllStock,
  makeGetPart,
  makeGetCWList,
  makeGetList30,
  makeGetPsList,
  makeGetPsSnapShot,
  makeGetListEtf,
  makeGetLoleSnapshot,
  makeGetConfig,
  makeGetSocketStatus,
  makeGetSnapShotBond,
  makeGetBondList,
} from '../../../lib/selector';

import {
  receiveReregister,
  setRegSymbol,
  unsetRegSymbol,
} from '../../../containers/socket/actions';

import ImgLoading from '../../../assets/img/loading.gif';

import { v4 as uuidv4 } from 'uuid';
import TblGroup from './layout/tblGroup';
import TblWatchList from './layout/tblWatchList';
import TblThoaThuan from './layout/tblThoaThuan';
import TblPhaiSinh from './layout/tblPhaisinh';
import TblLoLe from './layout/tblLoLe';

import { DMNGANH } from '../../../lib/storages';
import { getCodeByNameIndex, _diff2DateSecond } from '../../../utils';
import TblCW from './layout/tblCW';
import TblBond from './layout/tblTP';

// Hook
function usePrevious(value) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  const ref = useRef();

  // Store current value in ref
  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  // Return previous value (happens before update in useEffect above)
  return ref.current;
}

function PriceTable(props) {
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false);
  const [isPt, setIsPt] = useState(null);
  const [ptGr, setPtGr] = useState(null);
  const [timeLostFocus, setTimeLostFocus] = useState(null);

  const ws = useContext(WebSocketContext);
  const wc = useContext(WindowContext);

  const {windowIsActive} = wc;

  const {
    categoryId,
    socketReady,
    reRegister,
    catalogSelected,
    allStock,
    partSuccessful,
    partErrors,
    cwList,
    bondList,
    list30,
    listEtf,
    psList,
    unsetRegSymbol,
    regSym,
    config,
    serverStatus
  } = props;

  const prevCategoryId = usePrevious(props.categoryId);
  const prevCatalogSelected = usePrevious(props.catalogSelected);
  const prevAllStock = usePrevious(props.allStock);
  const preWindowIsActive = usePrevious(windowIsActive);
  const prevServerStatus = usePrevious(serverStatus);

  useEffect(() => {
    if(config){
      props.psListRequest();
    }
  }, [config]);

  useEffect(() => {
    if (
      catalogSelected &&
      ((allStock && !_.isEqual(allStock, prevAllStock)) ||
        !_.isEqual(catalogSelected, prevCatalogSelected) ||
        !_.isEqual(catalogSelected.path, prevCatalogSelected.path))
    ) {
      console.log(catalogSelected);
      fetchCategoryData(catalogSelected);
    }
  }, [allStock, catalogSelected]);

  useEffect(() => {
    if (socketReady) {
      _regisSocketData(categoryId);
      dispatch(receiveReregister(false))
    }
  }, [socketReady]);

  useEffect(() => {
    // console.log(wc)
    if (windowIsActive && preWindowIsActive === false && !_.isEqual(windowIsActive, preWindowIsActive)) {
      // console.log(wc, socketReady, serverStatus)
      const _diff = _diff2DateSecond(new Date(), timeLostFocus);
      // console.log(_diff, catalogSelected)
      if(_diff > 60){
        fetchCategoryData(catalogSelected);
      }
      if(!socketReady){
        ws.init();
      }
      if(socketReady && serverStatus === 'off'){
        ws.reconnectTrigger();
      }
    }
    if (windowIsActive === false && preWindowIsActive && !_.isEqual(windowIsActive, preWindowIsActive)) {
      setTimeLostFocus(new Date())
    }
  }, [windowIsActive]);

  useEffect(() => {
    console.log('reRegister', reRegister, socketReady)
    if (reRegister && socketReady) {
      console.log('reRegister', reRegister, socketReady, regSym)
      _handleRegisData(regSym)
      dispatch(receiveReregister(false))
    }
  }, [reRegister]);

  useEffect(() => {
    if (
      serverStatus &&
      serverStatus !== prevServerStatus &&
      serverStatus === 'on' &&
      prevServerStatus === 'off' &&
      socketReady
    ) {
      const _regSym = regSym;

      unsetRegSymbol();
      // console.log('reRegister', reRegister, socketReady, regSym);
      _handleRegisData(_regSym);
    }
  }, [serverStatus]);

  useEffect(() => {
    // leave old socket data
    _leaveSocketData(prevCategoryId);

    // register new socket data
    _regisSocketData(categoryId);
  }, [categoryId]);

  useEffect(() => {
    if (partSuccessful || (partErrors && !!partErrors.length))
      setIsLoading(false);
  }, [partSuccessful, partErrors]);

  useEffect(() => {
    if (isPt === 'CW' && cwList) {
      // load list chung quyen
      console.log(cwList);
      const {
        snapshotRequest,
        clearPartRequest,
        snapshotUnderlyingCWRequest,
      } = props;
      const symbolGr = _.map(cwList, 'code');
      const symbolUnderlying = _.map(cwList, 'underlying');
      // console.log(symbolGr.join(','));
      clearPartRequest();
      snapshotRequest(symbolGr.join(','));

      // console.log(symbolUnderlying.join(','));
      snapshotUnderlyingCWRequest(symbolUnderlying.join(','));
      _handleRegisData(symbolGr.join(',') + ',' + symbolUnderlying.join(','));
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }
  }, [cwList, isPt]);

  useEffect(() => {
    if (isPt === 'BOND' && bondList) {
      // load list chung quyen
      const {
        snapshotRequest,
        clearPartRequest,
      } = props;
      const symbolGr = _.map(bondList, 'code');
      // console.log(symbolGr.join(','));
      clearPartRequest();
      snapshotRequest(symbolGr.join(','));

      _handleRegisData(symbolGr.join(','));
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }
  }, [bondList, isPt]);

  useEffect(() => {
    if (isPt === 'PS' && psList && psList.length) {
      // load list phái sinh
      console.log(psList);
      const { psSnapshotRequest, clearPartRequest } = props;
      clearPartRequest();
      _handleLeaveData(regSym);
      unsetRegSymbol();
      _handleRegisData(psList.join(','));
      psSnapshotRequest(psList.join(','));
    }
  }, [psList, isPt]);

  useEffect(() => {
    // console.log(list30, isPt)
    if (isPt === 'LIST30' && list30) {
      // load list 30
      console.log(list30);
      const { snapshotRequest, clearPartRequest } = props;
      clearPartRequest();
      if (list30.list) {
        const _dtVN30 = list30.list.split(',').sort().join(',');
        snapshotRequest(_dtVN30);
        _handleLeaveData(regSym);
        unsetRegSymbol();

        _handleRegisData(list30.list);
      }
    }
  }, [list30, isPt]);

  useEffect(() => {
    // console.log(list30, isPt)
    if (isPt === 'ETF' && listEtf) {
      // load list 30
      console.log(listEtf);
      const { snapshotRequest, clearPartRequest, clearSnapshotRequest } = props;
      clearPartRequest();
      clearSnapshotRequest();
      if (listEtf.list) {
        const _dtETF = listEtf.list.split(',').sort().join(',');
        snapshotRequest(_dtETF);
        _handleLeaveData(regSym);
        unsetRegSymbol();

        _handleRegisData(listEtf.list);
      } else {
        _handleLeaveData(regSym);
        unsetRegSymbol();
      }
    }
  }, [listEtf, isPt]);

  const fetchCategoryData = (catalogSelected) => {
    const { snapshotRequest, clearPartRequest } = props;
    clearPartRequest();
    if (catalogSelected.symbols) {
      // danh muc nganh
      setIsPt(null);
      return snapshotRequest(catalogSelected.symbols);
    } else if (catalogSelected.type === 'group') {
      // set loading data
      setIsLoading(true);
      if(catalogSelected?.groupName === 'LOLE') {
        fetchLole(catalogSelected?.name)
      } else fetchGroup(catalogSelected.name, catalogSelected.groupName);
    } else {
      setIsPt(null);
      return snapshotRequest(catalogSelected.value.join(','));
    }
  };

  const fetchLole = (name) => {
    setIsPt('LOLE');
    _handleLeaveData(regSym);

    unsetRegSymbol();
    console.log(name)
    if(name === 'HNX') {
      const symbolHNX = _.map(
        _.filter(
          allStock,
          (o) => o.post_to === 'HNX' || o.post_to === 'STX'
        ),
        'stock_code'
      );
      _handleRequestOddlot(symbolHNX.join(','));
      // _handleRequestOddlot('HNX');
      _handleRegisData('ODD_HNX');
    } else {
      _handleRequestOddlotHSX();
      // _handleRequestOddlot('HSX');
      _handleRegisData('ODD_HSX')
    }
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }

  const fetchGroup = (_path, grName) => {
    _path =
      (_path === 'HOSE' || _path === 'STO') && grName !== 'ETF'
        ? 'HSX'
        : _path === 'STX'
        ? 'HNX'
        : _path === 'UPX'
        ? 'UPCOM'
        : _path;

    const { getStockByIdRequest, allStock, unsetRegSymbol, regSym } = props;

    if (_path === grName) {
      // get all group
      setIsLoading(true);
      const params = getCodeByNameIndex(grName);

      getStockByIdRequest(params);

      const symbolGr =
        grName === 'HSX'
          ? _.map(
              _.filter(
                allStock,
                (o) => o.post_to === 'HOSE' || o.post_to === 'STO'
              ),
              'stock_code'
            )
          : grName === 'HNX'
          ? _.map(
              _.filter(
                allStock,
                (o) => o.post_to === 'HNX' || o.post_to === 'STX'
              ),
              'stock_code'
            )
          : _.map(
              _.filter(
                allStock,
                (o) => o.post_to === 'UPCOM' || o.post_to === 'UPX'
              ),
              'stock_code'
            );

      _handleLeaveData(regSym);
      unsetRegSymbol();

      _handleRegisData(symbolGr.join(','));
      setIsPt(null);
    } else {
      // TODO: cho api lay theo nhom
      console.log(_path, grName);
      switch (_path) {
        case 'Phái sinh':
          setIsPt('PS');
          // props.psListRequest();
          setPtGr(grName);
          setIsLoading(false);
          break;
        case 'GD thoả thuận':
          setIsPt('PT');
          props.ptListRequest();
          setPtGr(grName);
          setIsLoading(false);
          break;

        case 'Chứng quyền':
          setIsPt('CW');
          _handleLeaveData(regSym);
          unsetRegSymbol();
          props.cwListRequest();
          break;

        case 'Trái phiếu':
          setIsPt('BOND');
          _handleLeaveData(regSym);
          unsetRegSymbol();
          props.bondListRequest();
          break;

        case 'Lô lẻ':
          setIsPt('LOLE');
          _handleLeaveData(regSym);
          unsetRegSymbol();
          const symbolHNX = _.map(
            _.filter(
              allStock,
              (o) => o.post_to === 'HNX' || o.post_to === 'STX'
            ),
            'stock_code'
          );
          _handleRequestOddlot(symbolHNX.join(','));
          _handleRegisData(symbolHNX.join(','));

          setTimeout(() => {
            setIsLoading(false);
          }, 2000);
          break;

        case 'VN30':
        case 'HNX30':
          setIsPt('LIST30');
          props.list30Request(_path === 'VN30' ? 'HSX30' : _path);
          setIsLoading(false);
          break;

        case 'HOSE':
        case 'HNX':
          setIsPt('ETF');
          props.listEtfRequest(_path);
          setIsLoading(false);
          break;
        default:
          console.log('cho api lay theo nhom khac');
          setIsPt(null);
          setIsLoading(false);
          break;
      }
    }
  };

  const _handleRequestOddlot = (syms) => {
    const { loleSnapshotRequest, clearPartRequest } = props;
    clearPartRequest();
    loleSnapshotRequest(syms);
  };

  const _handleRequestOddlotHSX = () => {
    const { loleHSXSnapshotRequest, clearPartRequest } = props;
    clearPartRequest();
    loleHSXSnapshotRequest();
  };

  const _handleRegisData = (symbol) => {
    const { setRegSymbol } = props;
    const payload = {
      action: 'join',
      data: symbol,
    };
    console.log('regis socket data', JSON.stringify(payload));
    setRegSymbol(symbol);
    return ws.sendMessage(payload);
  };

  const _handleLeaveData = (symbol) => {
    if(symbol){
      const payload = {
        action: 'leave',
        data: symbol,
      };
      console.log('leave socket data', JSON.stringify(payload));
      return ws.sendMessage(payload);
    }
  };

  const _regisSocketData = (categoryId = 'vn30') => {
    const { category, unsetRegSymbol, regSym } = props;
    if (categoryId.startsWith('nganh-')) {
      _handleLeaveData(regSym);
      unsetRegSymbol();

      // danh muc nganh
      const _filter = _.find(
        DMNGANH,
        (o) => o && o.path && o.path.endsWith(categoryId)
      );
      if (_filter) {
        _handleRegisData(_filter.symbols);
        return null;
      }
    } else {
      const catalogSelected = _.find(category, (o) =>
        o.path.endsWith('/bang-gia/' + categoryId)
      );
      if (catalogSelected && catalogSelected.type !== 'group') {
        _handleLeaveData(regSym);
        unsetRegSymbol();

        _handleRegisData(catalogSelected.value.join(','));
      } else return null;
    }
  };

  const _leaveSocketData = (categoryId) => {
    const { category } = props;
    if (!categoryId) return;
    if (categoryId.startsWith('nganh-')) {
      // danh muc nganh
      const _filter = _.find(
        DMNGANH,
        (o) => o && o.path && o.path.endsWith(categoryId)
      );
      if (_filter) {
        return _handleLeaveData(_filter.symbols);
      }
    } else {
      const catalogSelected = _.find(category, (o) =>
        o.path.endsWith('/bang-gia/' + categoryId)
      );
      if (catalogSelected && catalogSelected.type !== 'group') {
        return _handleLeaveData(catalogSelected.value.join(','));
      }
    }
    return null;
  };

  const { snapshot, typeIndex, partSnap, psSnapshot, lole } = props;

  return (
    <div className="d-flex flex-column">
      <NavbarPriceboard categoryId={categoryId} />
      {isPt === 'LOLE' && <TblLoLe partSnap={lole} typeIndex={typeIndex} />}
      {isPt === 'PT' && <TblThoaThuan ptGr={ptGr} typeIndex={typeIndex} />}
      {isPt === 'PS' && (
        <TblPhaiSinh
          partSnap={psSnapshot}
          typeIndex={typeIndex}
          psList={psList}
        />
      )}
      {(isPt === 'LIST30' || isPt === 'ETF') &&
        catalogSelected &&
        catalogSelected.type === 'group' && (
          <TblGroup partSnap={snapshot} typeIndex={typeIndex} />
        )}
      {isPt === 'CW' && catalogSelected && catalogSelected.type === 'group' && (
        <TblCW partSnap={snapshot} typeIndex={typeIndex} />
      )}
      {isPt === 'BOND' && catalogSelected && catalogSelected.type === 'group' && (
        <TblBond partSnap={snapshot} typeIndex={typeIndex} />
      )}
      {!isPt && catalogSelected && catalogSelected.type === 'group' && (
        <TblGroup partSnap={partSnap} typeIndex={typeIndex} />
      )}
      {!isPt && catalogSelected && catalogSelected.sequence && (
        <TblGroup partSnap={snapshot} typeIndex={typeIndex} />
      )}
      {!isPt && catalogSelected && catalogSelected.type !== 'group' && (
        <TblWatchList
          snapshot={snapshot}
          snapshotRequesting={props.snapshotRequesting}
          snapshotSuccessful={props.snapshotSuccessful}
          typeIndex={typeIndex}
          categoryId={categoryId}
        />
      )}
      {isLoading && (
        <div className="position-absolute loading-bottom">
          <img src={ImgLoading} alt="loading" style={{ height: '22px' }} />
          Loading
        </div>
      )}
    </div>
  );
}

const makeMapStateToProps = () => {
  const getToken = makeGetToken();
  const getDefaultAccount = makeGetDefaultAccount();
  const getCategory = makeGetCategory();
  const getAllStock = makeGetAllStock();
  const getTypeIndex = makeGetTypeIndex();
  const getCWList = makeGetCWList();
  const getBondList = makeGetBondList();
  const getList30 = makeGetList30();
  const getListEtf = makeGetListEtf();
  const getPsList = makeGetPsList();
  const getPart = makeGetPart();
  const getSnapShot = makeGetSnapShot();
  const getPsSnapShot = makeGetPsSnapShot();
  const getCatalogSelected = makeGetCategorySelected();
  const getLoleSnapshot = makeGetLoleSnapshot();
  const getConfig = makeGetConfig();
  const getSocketStatus = makeGetSocketStatus();

  const mapStateToProps = (state, props) => {
    return {
      token: getToken(state),
      config: getConfig(state),
      defaultAccount: getDefaultAccount(state),
      category: getCategory(state),
      allStock: getAllStock(state),
      typeIndex: getTypeIndex(state),
      cwList: getCWList(state),
      bondList: getBondList(state),
      list30: getList30(state),
      listEtf: getListEtf(state),
      psList: getPsList(state),
      partSnap: getPart(state),
      partErrors: state.priceBoard.partIdErrors,
      partSuccessful: state.priceBoard.partIdSuccessful,
      snapshot: getSnapShot(state),
      psSnapshot: getPsSnapShot(state),
      snapshotRequesting: state.priceBoard.snapshotRequesting,
      snapshotSuccessful: state.priceBoard.snapshotSuccessful,
      socketReady: state.socket.socketReady,
      reRegister: state.socket.reRegister,
      regSym: state.socket.regSym,
      catalogSelected: getCatalogSelected(state, props),
      lole: getLoleSnapshot(state),
      serverStatus: getSocketStatus(state),
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps, {
  snapshotRequest,
  snapshotUnderlyingCWRequest,
  psSnapshotRequest,
  ptListRequest,
  psListRequest,
  cwListRequest,
  bondListRequest,
  list30Request,
  listEtfRequest,
  clearPartRequest,
  clearSnapshotRequest,
  loleSnapshotRequest,
  loleHSXSnapshotRequest,
  getStockByIdRequest,
  setCategory,
  saveCategoryRequest,
  setRegSymbol,
  unsetRegSymbol,
})(PriceTable);
